

<label *ngIf='efastLabel' [innerHTML]="efastLabel">
</label>


<!--
<div *ngIf="efastErrorState" [@slideInOut]>
	<svg class="usa-icon" aria-hidden="true" style="color: #ff0048;"focusable="false" role="img">
		<use xlink:href="/assets/img/sprite.svg#error"></use>
	</svg>
	<span style="color: #ff0048;font-weight: bold;">{{efastErrorMsg}}</span>
</div>
-->

<div *ngIf="efastErrorState">
    <input [attr.aria-labelledby]="efastAriaLabelledBy" class="usa-input usa-input--error"  (input)="onInputHandler($event)" [(ngModel)]="efastModel" maxlength="{{efastMaxLength}}" >
</div>
<div *ngIf="!efastErrorState">
    <input [attr.aria-labelledby]="efastAriaLabelledBy" class="usa-input"  (input)="onInputHandler($event)" [(ngModel)]="efastModel" maxlength="{{efastMaxLength}}" >
</div>